import { computed } from "vue";
import { useStore } from "vuex";
import yup from "@component_path/inquiry_form_common_module/customValidation";

export const usePositionTypeField = (required, messages = {}) => {
  const fieldName = computed(() => "position_type");
  const validator = yup
    .string()
    .requirement(required, messages["requirement"] || "希望業種は必須項目です");

  return { validator, fieldName };
};

export const usePositionTypeStore = () => {
  const store = useStore();
  const positionType = computed(() => store.state.formData.position_type);
  const dispatcher = computed(() => "formData/setPositionType");
  const positionTypes = computed(() => store.state.masterData.positionTypes);
  const positionTypeText = computed(() => store.getters.positionTypeText);

  return { positionType, positionTypes, positionTypeText, dispatcher };
};
